import React, { useState, useEffect } from "react";
import "./styles/App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

// Sidebar & Navbar
import Sidebar from "./components/AdminSidebar";
import AdminNavbar from "./components/AdminNavbar";

// Pages
import Home from "./pages/AdminHome";
import About from "./pages/AdminAbout";
import Subscribe from "./pages/AdminSubscribe";
import AdminMatrimonial from "./pages/AdminMatrimonial";
import Publications from "./pages/AdminPublications";
import Vedapatshala from "./pages/AdminVedapatshala";
import Users from "./pages/AdminUsers";
import Subscribers from "./pages/AdminSubscribers";
import Account from "./pages/AdminAccount";
import AdminLogin from "./pages/AdminAuth";
import AdminForms from "./pages/AdminForms";
import AdminDonations from "./pages/AdminDonations";

// NEW PAGES
import Magazine from "./pages/AdminMagazine";
import Events from "./pages/AdminEvents";
import GuestBook from "./pages/AdminGuestBook";
import Gallery from "./pages/AdminGallery";
import Links from "./pages/AdminLinks";
import Bookings from "./pages/AdminBookings";

// ADMIN ORDERS PAGE
import AdminOrders from "./pages/AdminOrders";
import ShippingCharges from "./pages/AdminShippingCharges";
import AdminWhatsAppInbox from "./pages/AdminWhatsAppInbox";

// BLOG & ARTICLES
import AdminBlog from "./pages/AdminBlog";


/* =========================
   PROTECTED ROUTE
========================= */
const PrivateRoute = ({ children }) => {
  const isAuth = localStorage.getItem("adminAuth");
  return isAuth ? children : <Navigate to="/login" />;
};

/* =========================
   ADMIN LAYOUT
========================= */
const AdminLayout = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className={`admin-portal-root admin-layout ${isSidebarExpanded ? "expanded" : "collapsed"} ${isMobileOpen ? "mobile-open" : ""}`}>
      <AdminNavbar toggleSidebar={() => setIsMobileOpen((prev) => !prev)} />

      <Sidebar
        onToggle={setIsSidebarExpanded}
        setIsMobileOpen={setIsMobileOpen}
      />

      {/* 🌫 MOBILE OVERLAY */}
      {isMobileOpen && (
        <div
          className="admin-overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <main className="admin-content">
        {children}
      </main>
    </div>
  );
};

/* =========================
   APP
========================= */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>

        {/* PUBLIC */}
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* REDIRECT ROOT → HOME */}
        <Route path="/" element={<Navigate to="/admin/home" replace />} />

        {/* CORE PAGES - SUPPORT BOTH /admin/path AND /path */}
        <Route path="/admin/home" element={<PrivateRoute><AdminLayout><Home /></AdminLayout></PrivateRoute>} />
        <Route path="/home" element={<PrivateRoute><AdminLayout><Home /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/about" element={<PrivateRoute><AdminLayout><About /></AdminLayout></PrivateRoute>} />
        <Route path="/about" element={<PrivateRoute><AdminLayout><About /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/subscribe" element={<PrivateRoute><AdminLayout><Subscribe /></AdminLayout></PrivateRoute>} />
        <Route path="/subscribe" element={<PrivateRoute><AdminLayout><Subscribe /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/donations" element={<PrivateRoute><AdminLayout><AdminDonations /></AdminLayout></PrivateRoute>} />
        <Route path="/donations" element={<PrivateRoute><AdminLayout><AdminDonations /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/forms" element={<PrivateRoute><AdminLayout><AdminForms /></AdminLayout></PrivateRoute>} />
        <Route path="/forms" element={<PrivateRoute><AdminLayout><AdminForms /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/matrimonial" element={<PrivateRoute><AdminLayout><AdminMatrimonial /></AdminLayout></PrivateRoute>} />
        <Route path="/matrimonial" element={<PrivateRoute><AdminLayout><AdminMatrimonial /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/vivahaprapthi" element={<PrivateRoute><AdminLayout><AdminForms /></AdminLayout></PrivateRoute>} />
        <Route path="/vivahaprapthi" element={<PrivateRoute><AdminLayout><AdminForms /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/publications" element={<PrivateRoute><AdminLayout><Publications /></AdminLayout></PrivateRoute>} />
        <Route path="/publications" element={<PrivateRoute><AdminLayout><Publications /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/vedapatshala" element={<PrivateRoute><AdminLayout><Vedapatshala /></AdminLayout></PrivateRoute>} />
        <Route path="/vedapatshala" element={<PrivateRoute><AdminLayout><Vedapatshala /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/users" element={<PrivateRoute><AdminLayout><Users /></AdminLayout></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><AdminLayout><Users /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/subscribers" element={<PrivateRoute><AdminLayout><Subscribers /></AdminLayout></PrivateRoute>} />
        <Route path="/subscribers" element={<PrivateRoute><AdminLayout><Subscribers /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/account" element={<PrivateRoute><AdminLayout><Account /></AdminLayout></PrivateRoute>} />
        <Route path="/account" element={<PrivateRoute><AdminLayout><Account /></AdminLayout></PrivateRoute>} />

        {/* NEW MODULES */}
        <Route path="/admin/magazine" element={<PrivateRoute><AdminLayout><Magazine /></AdminLayout></PrivateRoute>} />
        <Route path="/magazine" element={<PrivateRoute><AdminLayout><Magazine /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/events" element={<PrivateRoute><AdminLayout><Events /></AdminLayout></PrivateRoute>} />
        <Route path="/events" element={<PrivateRoute><AdminLayout><Events /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/guest-book" element={<PrivateRoute><AdminLayout><GuestBook /></AdminLayout></PrivateRoute>} />
        <Route path="/guest-book" element={<PrivateRoute><AdminLayout><GuestBook /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/gallery" element={<PrivateRoute><AdminLayout><Gallery /></AdminLayout></PrivateRoute>} />
        <Route path="/gallery" element={<PrivateRoute><AdminLayout><Gallery /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/links" element={<PrivateRoute><AdminLayout><Links /></AdminLayout></PrivateRoute>} />
        <Route path="/links" element={<PrivateRoute><AdminLayout><Links /></AdminLayout></PrivateRoute>} />

        <Route path="/admin/bookings" element={<PrivateRoute><AdminLayout><Bookings /></AdminLayout></PrivateRoute>} />
        <Route path="/bookings" element={<PrivateRoute><AdminLayout><Bookings /></AdminLayout></PrivateRoute>} />

        {/* BLOG & ARTICLES */}
        <Route path="/admin/blog" element={<PrivateRoute><AdminLayout><AdminBlog /></AdminLayout></PrivateRoute>} />
        <Route path="/blog" element={<PrivateRoute><AdminLayout><AdminBlog /></AdminLayout></PrivateRoute>} />

        {/* ADMIN ORDERS */}
        <Route path="/admin/admin-orders" element={<PrivateRoute><AdminLayout><AdminOrders /></AdminLayout></PrivateRoute>} />
        <Route path="/admin-orders" element={<PrivateRoute><AdminLayout><AdminOrders /></AdminLayout></PrivateRoute>} />

        {/* SHIPPING CHARGES */}
        <Route path="/admin/shipping-charges" element={<PrivateRoute><AdminLayout><ShippingCharges /></AdminLayout></PrivateRoute>} />
        <Route path="/shipping-charges" element={<PrivateRoute><AdminLayout><ShippingCharges /></AdminLayout></PrivateRoute>} />

        {/* WHATSAPP INBOX */}
        <Route path="/admin/whatsapp-inbox" element={<PrivateRoute><AdminLayout><AdminWhatsAppInbox /></AdminLayout></PrivateRoute>} />
        <Route path="/whatsapp-inbox" element={<PrivateRoute><AdminLayout><AdminWhatsAppInbox /></AdminLayout></PrivateRoute>} />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/admin/home" replace />} />

      </Routes>
    </Router>
  );
}

export default App;